import type { ReactNode } from "react";

interface ResourceStateProps {
  readonly action?: ReactNode;
  readonly description: string;
  readonly kind: "degraded" | "empty" | "error" | "forbidden" | "loading" | "not-found" | "stale";
  readonly title: string;
}

export function ResourceState({ action, description, kind, title }: ResourceStateProps) {
  const live = kind === "loading" ? "polite" : undefined;
  return (
    <section className={`resource-state resource-state--${kind}`} aria-live={live}>
      <span className="resource-state__marker" aria-hidden="true" />
      <div>
        <h2>{title}</h2>
        <p>{description}</p>
        {action}
      </div>
    </section>
  );
}
